import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notfound-page',
  templateUrl: './notfound-page.component.html',
  styleUrls: ['./notfound-page.component.scss']
})
export class NotfoundPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
